import {
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

import { TableCellAlighnRight } from '../../styled/Backup.styled';

type TotalRequestsTableProps = {
  totalRequests: number | null;
};

const TotalRequestsTable = ({ totalRequests }: TotalRequestsTableProps) => {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="total requests">
        <TableHead>
          <TableRow>
            <TableCell>Total Requests</TableCell>
            <TableCellAlighnRight>{totalRequests}</TableCellAlighnRight>
          </TableRow>
        </TableHead>
      </Table>
    </TableContainer>
  );
};

export default TotalRequestsTable;
